import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { theme } from '../../../theme';

export const IconExpandable = styled(FontAwesomeIcon)`
  color: ${theme.colors.secondary};
`;

export const DivFnTable = styled.table`
  color: ${theme.colors.textPrimary};
  font-style: normal;
  font-size: 14px;
  table-layout: fixed;

  &.table {
    thead {
      background-color: ${theme.colors.surfaceFront};

      tr {
        th {
          font-weight: 600;
          line-height: 17px;
          vertical-align: middle;
          padding: 0.615rem 0.923rem;
          border: none;
          background-color: ${theme.colors.surfaceFront};
        }
      }
    }

    tbody {
      width: 100%;
      font-weight: 500;
      line-height: 1.538rem;

      .fn-expanded-tr {
        width: 100%;

        .fn-expanded-td {
          width: 100%;
        }
      }

      .fn-group-td,
      .fn-group-tr {
        width: 100%;
        padding: 0 !important;
      }

      tr:first-child {
        td {
          padding-top: 2rem;
        }
      }

      tr:last-child {
        td {
          padding-bottom: 2rem;
        }
      }

      tr {
        td {
          font-weight: 500;
          line-height: 1.538rem;
          vertical-align: middle;
          padding: 0.615rem 0.923rem;
          border: none;
          background-color: ${theme.colors.white};
          word-break: break-word;
        }
      }

      tr.filters-row {
        td {
          padding: 0;
        }
      }
    }

    &.sticky-head {
      thead {
        position: sticky;
        top: 0;
        z-index: 4;
      }
    }
  }
`;

export const DivFnLoader = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 12;
  .loader {
    display: inline-block;
    width: 1.846rem;
    height: 1.846rem;
    &:after {
      content: ' ';
      display: block;
      width: 1.846rem;
      height: 1.846rem;
      margin: 1px;
      border-radius: 50%;
      border-width: 2px;
      border-style: solid;
      border-color: ${theme.colors.primary} ${theme.colors.primary} ${theme.colors.primary} transparent;
      animation: lds-dual-ring 0.5s linear infinite;
    }
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const DivTableWrapper = styled.div`
  position: relative;
  width: 100%;
  z-index: 1;
  margin: auto;
  height: 100%;
  overflow: auto;

  th[data-sticky-td='true'] {
    z-index: 4 !important;
  }

  [data-sticky-td] {
    width: fit-content;
    background: ${theme.colors.white};
  }
`;

export const DivContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto 1fr auto;
  grid-template-columns: 1fr;
  overflow: hidden;
  width: 100%;
  
  &.bom-table {
    .fn-table-wrapper {
      padding: 0 1px;
    }
    
    .table {
      height: auto;
      max-height: 30.769rem;

      thead {
        tr {
          &:last-child {
            border-bottom: 1px solid ${theme.colors.secondary};
          }

          th {
            padding: 0.615rem 1.154rem;
          }
        }
      }

      tbody {
        td {
          padding: 0.615rem 1.154rem;
          border: 1px solid ${theme.colors.secondary};
          border-collapse: collapse;
        }

        tr {
          &:first-child {
            td {
              padding: 0.615rem 1.154rem;
            }
          }

          &:last-child {
            td {
              padding: 0.615rem 1.154rem;
            }
          }
        }
      }
    }
  }
  &.submission-table {
    .table {
      thead {
        tr {
          th {
            padding: 1rem 1.154rem;
          }
        }
      }

      tbody {
        tr:first-child {
          td {
            padding-top: 2rem;
          }
        }
        td {
          padding: 1rem 1.154rem;
        }
      }
    }
  }
  &.modal-table {
    &.hidden {
      display: none;
    }
    .table {
      margin-bottom: 0;
      thead th {
        font-size: 1.078rem;
        padding: 1.35rem 1.154rem;
        background-color: ${theme.colors.surfaceBase};
      }
    }
    &-header-off .table {
      thead {
        visibility: collapse;
      }
    }
  }
  &.inventory.modal-table {
    .table {
      thead th {
        &:last-of-type {
          // For 'sticky' to work
          width: 120px !important;
          ${theme.up(theme.breakpoints.lg)} {
            width: auto !important;
          }
        }
      }
      tbody {
        tr {
          &:last-child {
            td {
              border-top: 1px solid ${theme.colors.line};
              &:first-of-type {
                font-weight: 600;
              }
            }
          }
          &:first-child {
            td {
              padding-top: 1rem;
              border-top: none;
            }
          }
        }
      }
  }
`;

export const DivPaginationBlock = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  ul.ant-pagination {
    margin-left: auto;
  }
`;

export const upperHeaderStyle = {
  backgroundColor: theme.colors.surfaceBase,
  padding: '0.8rem 1.154rem'
};

export const headerStyle = {
  backgroundColor: theme.bomTable.backgroundColor,
  padding: '1.35rem 1.154rem'
};

export const DivPaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
`;
